import { render } from "./VerifyIdentityBanner.vue?vue&type=template&id=eccd50d8&scoped=true"
import script from "./VerifyIdentityBanner.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityBanner.vue?vue&type=script&lang=js"

import "./VerifyIdentityBanner.vue?vue&type=style&index=0&id=eccd50d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1672060877/src/vivamo-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eccd50d8"]])

export default __exports__